const sourceType=954211;
const partnerType=4;
export {
    sourceType,
    partnerType
}